// Exposure's pictures (Dhanur, 27 Oct 2026: the view is Exposure, and the
// title and the selected name read as one phrase, "Exposure, by market"),
// kept in the URL as `exposure` so a picture can be linked and comes back on
// reload. Names are descriptive, in the buyer's
// words (Dhanur, 26 Oct 2026): what each picture is of, never a coined term.
// The switch reads in this order (Dhanur, 28 Oct 2026).
export enum ExposureView {
  GEOGRAPHY = "by-market",
  CUSTOMER_ACTIVITY = "by-customer-activity",
  SINCE_ONBOARDING = "since-onboard",
}

export const EXPOSURE_VIEWS = Object.values(ExposureView)

export const dataByExposureView: Record<ExposureView, { label: string }> = {
  [ExposureView.GEOGRAPHY]: { label: "By Market" },
  [ExposureView.CUSTOMER_ACTIVITY]: { label: "By Customer Activity" },
  [ExposureView.SINCE_ONBOARDING]: { label: "Since Onboard" },
}

// Customer Activity's one control: the window the activity is counted over.
// "Recent" is the product's Recent, the last 90 days, in the fewest whole
// quarters that cover it (the data is quarterly); "Since onboarding" is from
// the quarter the buyer onboarded each company.
export enum ActivityWindow {
  RECENT = "recent",
  SINCE_ONBOARDING = "since-onboarding",
}

// Geography's one control: each company once in every state where it has a
// recorded location (the default, Dhanur, 28 Oct 2026), or once, in its
// headquarters state.
export enum GeographyBasis {
  LOCATIONS = "locations",
  HEADQUARTERS = "headquarters",
}
